//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getImage from '~/helpers/getImage';

export default {
    name: 'UsefulInformation',
    props: {
        isMainPage: {
            type: Boolean,
            default: false
        },
        pages: { type: Array, required: true },
        fullWidth: { type: Boolean, default: true }
    },
    methods: {
        getBottomImage(url) {
            return getImage(url, 'rs:fit:314:157');
        }
    }
};
